import { AIContextPluginStateDef } from '../components/api-docs/AIChatbot/AIChatbotTypes';
import { getHeaders, fetcher } from './ApiClient';

export type AIChatbotConfigs = {
    isAllowedInSubscription: boolean;
    isAiEnabled: boolean;
    welcomeMessage: string;
    contextPlugins: AIContextPluginStateDef;
    additionalInformation?: { email: string };
};

export type AIChatbotConfigsPost = {
    isEnabled: boolean;
    welcomeMessage: string;
    contextPlugins: AIContextPluginStateDef;
};

const uri = `api-groups/{apiGroupId}/ai-configuration`;

const getAIChatbotConfigs = (): Promise<AIChatbotConfigs> => {
    return fetcher<AIChatbotConfigs>(uri, 'GET', getHeaders());
};

const updateAIChatbotConfigs = (body: AIChatbotConfigsPost): Promise<AIChatbotConfigsPost> => {
    return fetcher<AIChatbotConfigsPost>(uri, 'POST', getHeaders(), body);
};

export { getAIChatbotConfigs, updateAIChatbotConfigs };
